export const ArrayUtils = {
  lastItem<T>(array: T[]) { return array[array.length - 1]; },
};
